// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/images/bottom-dropdown-icon.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*--------------Mixins------------------*/
.ml-0 {
  margin-left: 0px !important;
}

.mr-0 {
  margin-right: 0px !important;
}

.mt-0 {
  margin-top: 0px !important;
}

.mb-0 {
  margin-bottom: 0px !important;
}

.mx-0 {
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.my-0 {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}

.ml-1 {
  margin-left: 4px !important;
}

.mr-1 {
  margin-right: 4px !important;
}

.mt-1 {
  margin-top: 4px !important;
}

.mb-1 {
  margin-bottom: 4px !important;
}

.mx-1 {
  margin-left: 4px !important;
  margin-right: 4px !important;
}

.my-1 {
  margin-top: 4px !important;
  margin-bottom: 4px !important;
}

.ml-2 {
  margin-left: 8px !important;
}

.mr-2 {
  margin-right: 8px !important;
}

.mt-2 {
  margin-top: 8px !important;
}

.mb-2 {
  margin-bottom: 8px !important;
}

.mx-2 {
  margin-left: 8px !important;
  margin-right: 8px !important;
}

.my-2 {
  margin-top: 8px !important;
  margin-bottom: 8px !important;
}

.ml-3 {
  margin-left: 12px !important;
}

.mr-3 {
  margin-right: 12px !important;
}

.mt-3 {
  margin-top: 12px !important;
}

.mb-3 {
  margin-bottom: 12px !important;
}

.mx-3 {
  margin-left: 12px !important;
  margin-right: 12px !important;
}

.my-3 {
  margin-top: 12px !important;
  margin-bottom: 12px !important;
}

.ml-4 {
  margin-left: 16px !important;
}

.mr-4 {
  margin-right: 16px !important;
}

.mt-4 {
  margin-top: 16px !important;
}

.mb-4 {
  margin-bottom: 16px !important;
}

.mx-4 {
  margin-left: 16px !important;
  margin-right: 16px !important;
}

.my-4 {
  margin-top: 16px !important;
  margin-bottom: 16px !important;
}

.ml-5 {
  margin-left: 20px !important;
}

.mr-5 {
  margin-right: 20px !important;
}

.mt-5 {
  margin-top: 20px !important;
}

.mb-5 {
  margin-bottom: 20px !important;
}

.mx-5 {
  margin-left: 20px !important;
  margin-right: 20px !important;
}

.my-5 {
  margin-top: 20px !important;
  margin-bottom: 20px !important;
}

.ml-6 {
  margin-left: 24px !important;
}

.mr-6 {
  margin-right: 24px !important;
}

.mt-6 {
  margin-top: 24px !important;
}

.mb-6 {
  margin-bottom: 24px !important;
}

.mx-6 {
  margin-left: 24px !important;
  margin-right: 24px !important;
}

.my-6 {
  margin-top: 24px !important;
  margin-bottom: 24px !important;
}

.ml-7 {
  margin-left: 28px !important;
}

.mr-7 {
  margin-right: 28px !important;
}

.mt-7 {
  margin-top: 28px !important;
}

.mb-7 {
  margin-bottom: 28px !important;
}

.mx-7 {
  margin-left: 28px !important;
  margin-right: 28px !important;
}

.my-7 {
  margin-top: 28px !important;
  margin-bottom: 28px !important;
}

.ml-8 {
  margin-left: 32px !important;
}

.mr-8 {
  margin-right: 32px !important;
}

.mt-8 {
  margin-top: 32px !important;
}

.mb-8 {
  margin-bottom: 32px !important;
}

.mx-8 {
  margin-left: 32px !important;
  margin-right: 32px !important;
}

.my-8 {
  margin-top: 32px !important;
  margin-bottom: 32px !important;
}

.ml-9 {
  margin-left: 36px !important;
}

.mr-9 {
  margin-right: 36px !important;
}

.mt-9 {
  margin-top: 36px !important;
}

.mb-9 {
  margin-bottom: 36px !important;
}

.mx-9 {
  margin-left: 36px !important;
  margin-right: 36px !important;
}

.my-9 {
  margin-top: 36px !important;
  margin-bottom: 36px !important;
}

.ml-10 {
  margin-left: 40px !important;
}

.mr-10 {
  margin-right: 40px !important;
}

.mt-10 {
  margin-top: 40px !important;
}

.mb-10 {
  margin-bottom: 40px !important;
}

.mx-10 {
  margin-left: 40px !important;
  margin-right: 40px !important;
}

.my-10 {
  margin-top: 40px !important;
  margin-bottom: 40px !important;
}

.ml-11 {
  margin-left: 44px !important;
}

.mr-11 {
  margin-right: 44px !important;
}

.mt-11 {
  margin-top: 44px !important;
}

.mb-11 {
  margin-bottom: 44px !important;
}

.mx-11 {
  margin-left: 44px !important;
  margin-right: 44px !important;
}

.my-11 {
  margin-top: 44px !important;
  margin-bottom: 44px !important;
}

.ml-12 {
  margin-left: 48px !important;
}

.mr-12 {
  margin-right: 48px !important;
}

.mt-12 {
  margin-top: 48px !important;
}

.mb-12 {
  margin-bottom: 48px !important;
}

.mx-12 {
  margin-left: 48px !important;
  margin-right: 48px !important;
}

.my-12 {
  margin-top: 48px !important;
  margin-bottom: 48px !important;
}

.ml-13 {
  margin-left: 52px !important;
}

.mr-13 {
  margin-right: 52px !important;
}

.mt-13 {
  margin-top: 52px !important;
}

.mb-13 {
  margin-bottom: 52px !important;
}

.mx-13 {
  margin-left: 52px !important;
  margin-right: 52px !important;
}

.my-13 {
  margin-top: 52px !important;
  margin-bottom: 52px !important;
}

.ml-14 {
  margin-left: 56px !important;
}

.mr-14 {
  margin-right: 56px !important;
}

.mt-14 {
  margin-top: 56px !important;
}

.mb-14 {
  margin-bottom: 56px !important;
}

.mx-14 {
  margin-left: 56px !important;
  margin-right: 56px !important;
}

.my-14 {
  margin-top: 56px !important;
  margin-bottom: 56px !important;
}

.ml-15 {
  margin-left: 60px !important;
}

.mr-15 {
  margin-right: 60px !important;
}

.mt-15 {
  margin-top: 60px !important;
}

.mb-15 {
  margin-bottom: 60px !important;
}

.mx-15 {
  margin-left: 60px !important;
  margin-right: 60px !important;
}

.my-15 {
  margin-top: 60px !important;
  margin-bottom: 60px !important;
}

.ml-16 {
  margin-left: 64px !important;
}

.mr-16 {
  margin-right: 64px !important;
}

.mt-16 {
  margin-top: 64px !important;
}

.mb-16 {
  margin-bottom: 64px !important;
}

.mx-16 {
  margin-left: 64px !important;
  margin-right: 64px !important;
}

.my-16 {
  margin-top: 64px !important;
  margin-bottom: 64px !important;
}

.ml-17 {
  margin-left: 68px !important;
}

.mr-17 {
  margin-right: 68px !important;
}

.mt-17 {
  margin-top: 68px !important;
}

.mb-17 {
  margin-bottom: 68px !important;
}

.mx-17 {
  margin-left: 68px !important;
  margin-right: 68px !important;
}

.my-17 {
  margin-top: 68px !important;
  margin-bottom: 68px !important;
}

.ml-18 {
  margin-left: 72px !important;
}

.mr-18 {
  margin-right: 72px !important;
}

.mt-18 {
  margin-top: 72px !important;
}

.mb-18 {
  margin-bottom: 72px !important;
}

.mx-18 {
  margin-left: 72px !important;
  margin-right: 72px !important;
}

.my-18 {
  margin-top: 72px !important;
  margin-bottom: 72px !important;
}

.ml-19 {
  margin-left: 76px !important;
}

.mr-19 {
  margin-right: 76px !important;
}

.mt-19 {
  margin-top: 76px !important;
}

.mb-19 {
  margin-bottom: 76px !important;
}

.mx-19 {
  margin-left: 76px !important;
  margin-right: 76px !important;
}

.my-19 {
  margin-top: 76px !important;
  margin-bottom: 76px !important;
}

.pl-0 {
  padding-left: 0px !important;
}

.pr-0 {
  padding-right: 0px !important;
}

.pt-0 {
  padding-top: 0px !important;
}

.pb-0 {
  padding-bottom: 0px !important;
}

.px-0 {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.py-0 {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.pl-1 {
  padding-left: 4px !important;
}

.pr-1 {
  padding-right: 4px !important;
}

.pt-1 {
  padding-top: 4px !important;
}

.pb-1 {
  padding-bottom: 4px !important;
}

.px-1 {
  padding-left: 4px !important;
  padding-right: 4px !important;
}

.py-1 {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}

.pl-2 {
  padding-left: 8px !important;
}

.pr-2 {
  padding-right: 8px !important;
}

.pt-2 {
  padding-top: 8px !important;
}

.pb-2 {
  padding-bottom: 8px !important;
}

.px-2 {
  padding-left: 8px !important;
  padding-right: 8px !important;
}

.py-2 {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

.pl-3 {
  padding-left: 12px !important;
}

.pr-3 {
  padding-right: 12px !important;
}

.pt-3 {
  padding-top: 12px !important;
}

.pb-3 {
  padding-bottom: 12px !important;
}

.px-3 {
  padding-left: 12px !important;
  padding-right: 12px !important;
}

.py-3 {
  padding-top: 12px !important;
  padding-bottom: 12px !important;
}

.pl-4 {
  padding-left: 16px !important;
}

.pr-4 {
  padding-right: 16px !important;
}

.pt-4 {
  padding-top: 16px !important;
}

.pb-4 {
  padding-bottom: 16px !important;
}

.px-4 {
  padding-left: 16px !important;
  padding-right: 16px !important;
}

.py-4 {
  padding-top: 16px !important;
  padding-bottom: 16px !important;
}

.pl-5 {
  padding-left: 20px !important;
}

.pr-5 {
  padding-right: 20px !important;
}

.pt-5 {
  padding-top: 20px !important;
}

.pb-5 {
  padding-bottom: 20px !important;
}

.px-5 {
  padding-left: 20px !important;
  padding-right: 20px !important;
}

.py-5 {
  padding-top: 20px !important;
  padding-bottom: 20px !important;
}

.pl-6 {
  padding-left: 24px !important;
}

.pr-6 {
  padding-right: 24px !important;
}

.pt-6 {
  padding-top: 24px !important;
}

.pb-6 {
  padding-bottom: 24px !important;
}

.px-6 {
  padding-left: 24px !important;
  padding-right: 24px !important;
}

.py-6 {
  padding-top: 24px !important;
  padding-bottom: 24px !important;
}

.pl-7 {
  padding-left: 28px !important;
}

.pr-7 {
  padding-right: 28px !important;
}

.pt-7 {
  padding-top: 28px !important;
}

.pb-7 {
  padding-bottom: 28px !important;
}

.px-7 {
  padding-left: 28px !important;
  padding-right: 28px !important;
}

.py-7 {
  padding-top: 28px !important;
  padding-bottom: 28px !important;
}

.pl-8 {
  padding-left: 32px !important;
}

.pr-8 {
  padding-right: 32px !important;
}

.pt-8 {
  padding-top: 32px !important;
}

.pb-8 {
  padding-bottom: 32px !important;
}

.px-8 {
  padding-left: 32px !important;
  padding-right: 32px !important;
}

.py-8 {
  padding-top: 32px !important;
  padding-bottom: 32px !important;
}

.pl-9 {
  padding-left: 36px !important;
}

.pr-9 {
  padding-right: 36px !important;
}

.pt-9 {
  padding-top: 36px !important;
}

.pb-9 {
  padding-bottom: 36px !important;
}

.px-9 {
  padding-left: 36px !important;
  padding-right: 36px !important;
}

.py-9 {
  padding-top: 36px !important;
  padding-bottom: 36px !important;
}

.pl-10 {
  padding-left: 40px !important;
}

.pr-10 {
  padding-right: 40px !important;
}

.pt-10 {
  padding-top: 40px !important;
}

.pb-10 {
  padding-bottom: 40px !important;
}

.px-10 {
  padding-left: 40px !important;
  padding-right: 40px !important;
}

.py-10 {
  padding-top: 40px !important;
  padding-bottom: 40px !important;
}

.pl-11 {
  padding-left: 44px !important;
}

.pr-11 {
  padding-right: 44px !important;
}

.pt-11 {
  padding-top: 44px !important;
}

.pb-11 {
  padding-bottom: 44px !important;
}

.px-11 {
  padding-left: 44px !important;
  padding-right: 44px !important;
}

.py-11 {
  padding-top: 44px !important;
  padding-bottom: 44px !important;
}

.pl-12 {
  padding-left: 48px !important;
}

.pr-12 {
  padding-right: 48px !important;
}

.pt-12 {
  padding-top: 48px !important;
}

.pb-12 {
  padding-bottom: 48px !important;
}

.px-12 {
  padding-left: 48px !important;
  padding-right: 48px !important;
}

.py-12 {
  padding-top: 48px !important;
  padding-bottom: 48px !important;
}

.pl-13 {
  padding-left: 52px !important;
}

.pr-13 {
  padding-right: 52px !important;
}

.pt-13 {
  padding-top: 52px !important;
}

.pb-13 {
  padding-bottom: 52px !important;
}

.px-13 {
  padding-left: 52px !important;
  padding-right: 52px !important;
}

.py-13 {
  padding-top: 52px !important;
  padding-bottom: 52px !important;
}

.pl-14 {
  padding-left: 56px !important;
}

.pr-14 {
  padding-right: 56px !important;
}

.pt-14 {
  padding-top: 56px !important;
}

.pb-14 {
  padding-bottom: 56px !important;
}

.px-14 {
  padding-left: 56px !important;
  padding-right: 56px !important;
}

.py-14 {
  padding-top: 56px !important;
  padding-bottom: 56px !important;
}

.pl-15 {
  padding-left: 60px !important;
}

.pr-15 {
  padding-right: 60px !important;
}

.pt-15 {
  padding-top: 60px !important;
}

.pb-15 {
  padding-bottom: 60px !important;
}

.px-15 {
  padding-left: 60px !important;
  padding-right: 60px !important;
}

.py-15 {
  padding-top: 60px !important;
  padding-bottom: 60px !important;
}

.pl-16 {
  padding-left: 64px !important;
}

.pr-16 {
  padding-right: 64px !important;
}

.pt-16 {
  padding-top: 64px !important;
}

.pb-16 {
  padding-bottom: 64px !important;
}

.px-16 {
  padding-left: 64px !important;
  padding-right: 64px !important;
}

.py-16 {
  padding-top: 64px !important;
  padding-bottom: 64px !important;
}

.pl-17 {
  padding-left: 68px !important;
}

.pr-17 {
  padding-right: 68px !important;
}

.pt-17 {
  padding-top: 68px !important;
}

.pb-17 {
  padding-bottom: 68px !important;
}

.px-17 {
  padding-left: 68px !important;
  padding-right: 68px !important;
}

.py-17 {
  padding-top: 68px !important;
  padding-bottom: 68px !important;
}

.pl-18 {
  padding-left: 72px !important;
}

.pr-18 {
  padding-right: 72px !important;
}

.pt-18 {
  padding-top: 72px !important;
}

.pb-18 {
  padding-bottom: 72px !important;
}

.px-18 {
  padding-left: 72px !important;
  padding-right: 72px !important;
}

.py-18 {
  padding-top: 72px !important;
  padding-bottom: 72px !important;
}

.pl-19 {
  padding-left: 76px !important;
}

.pr-19 {
  padding-right: 76px !important;
}

.pt-19 {
  padding-top: 76px !important;
}

.pb-19 {
  padding-bottom: 76px !important;
}

.px-19 {
  padding-left: 76px !important;
  padding-right: 76px !important;
}

.py-19 {
  padding-top: 76px !important;
  padding-bottom: 76px !important;
}

/*--------------Mixins------------------*/
.ml-0 {
  margin-left: 0px !important;
}

.mr-0 {
  margin-right: 0px !important;
}

.mt-0 {
  margin-top: 0px !important;
}

.mb-0 {
  margin-bottom: 0px !important;
}

.mx-0 {
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.my-0 {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}

.ml-1 {
  margin-left: 4px !important;
}

.mr-1 {
  margin-right: 4px !important;
}

.mt-1 {
  margin-top: 4px !important;
}

.mb-1 {
  margin-bottom: 4px !important;
}

.mx-1 {
  margin-left: 4px !important;
  margin-right: 4px !important;
}

.my-1 {
  margin-top: 4px !important;
  margin-bottom: 4px !important;
}

.ml-2 {
  margin-left: 8px !important;
}

.mr-2 {
  margin-right: 8px !important;
}

.mt-2 {
  margin-top: 8px !important;
}

.mb-2 {
  margin-bottom: 8px !important;
}

.mx-2 {
  margin-left: 8px !important;
  margin-right: 8px !important;
}

.my-2 {
  margin-top: 8px !important;
  margin-bottom: 8px !important;
}

.ml-3 {
  margin-left: 12px !important;
}

.mr-3 {
  margin-right: 12px !important;
}

.mt-3 {
  margin-top: 12px !important;
}

.mb-3 {
  margin-bottom: 12px !important;
}

.mx-3 {
  margin-left: 12px !important;
  margin-right: 12px !important;
}

.my-3 {
  margin-top: 12px !important;
  margin-bottom: 12px !important;
}

.ml-4 {
  margin-left: 16px !important;
}

.mr-4 {
  margin-right: 16px !important;
}

.mt-4 {
  margin-top: 16px !important;
}

.mb-4 {
  margin-bottom: 16px !important;
}

.mx-4 {
  margin-left: 16px !important;
  margin-right: 16px !important;
}

.my-4 {
  margin-top: 16px !important;
  margin-bottom: 16px !important;
}

.ml-5 {
  margin-left: 20px !important;
}

.mr-5 {
  margin-right: 20px !important;
}

.mt-5 {
  margin-top: 20px !important;
}

.mb-5 {
  margin-bottom: 20px !important;
}

.mx-5 {
  margin-left: 20px !important;
  margin-right: 20px !important;
}

.my-5 {
  margin-top: 20px !important;
  margin-bottom: 20px !important;
}

.ml-6 {
  margin-left: 24px !important;
}

.mr-6 {
  margin-right: 24px !important;
}

.mt-6 {
  margin-top: 24px !important;
}

.mb-6 {
  margin-bottom: 24px !important;
}

.mx-6 {
  margin-left: 24px !important;
  margin-right: 24px !important;
}

.my-6 {
  margin-top: 24px !important;
  margin-bottom: 24px !important;
}

.ml-7 {
  margin-left: 28px !important;
}

.mr-7 {
  margin-right: 28px !important;
}

.mt-7 {
  margin-top: 28px !important;
}

.mb-7 {
  margin-bottom: 28px !important;
}

.mx-7 {
  margin-left: 28px !important;
  margin-right: 28px !important;
}

.my-7 {
  margin-top: 28px !important;
  margin-bottom: 28px !important;
}

.ml-8 {
  margin-left: 32px !important;
}

.mr-8 {
  margin-right: 32px !important;
}

.mt-8 {
  margin-top: 32px !important;
}

.mb-8 {
  margin-bottom: 32px !important;
}

.mx-8 {
  margin-left: 32px !important;
  margin-right: 32px !important;
}

.my-8 {
  margin-top: 32px !important;
  margin-bottom: 32px !important;
}

.ml-9 {
  margin-left: 36px !important;
}

.mr-9 {
  margin-right: 36px !important;
}

.mt-9 {
  margin-top: 36px !important;
}

.mb-9 {
  margin-bottom: 36px !important;
}

.mx-9 {
  margin-left: 36px !important;
  margin-right: 36px !important;
}

.my-9 {
  margin-top: 36px !important;
  margin-bottom: 36px !important;
}

.ml-10 {
  margin-left: 40px !important;
}

.mr-10 {
  margin-right: 40px !important;
}

.mt-10 {
  margin-top: 40px !important;
}

.mb-10 {
  margin-bottom: 40px !important;
}

.mx-10 {
  margin-left: 40px !important;
  margin-right: 40px !important;
}

.my-10 {
  margin-top: 40px !important;
  margin-bottom: 40px !important;
}

.ml-11 {
  margin-left: 44px !important;
}

.mr-11 {
  margin-right: 44px !important;
}

.mt-11 {
  margin-top: 44px !important;
}

.mb-11 {
  margin-bottom: 44px !important;
}

.mx-11 {
  margin-left: 44px !important;
  margin-right: 44px !important;
}

.my-11 {
  margin-top: 44px !important;
  margin-bottom: 44px !important;
}

.ml-12 {
  margin-left: 48px !important;
}

.mr-12 {
  margin-right: 48px !important;
}

.mt-12 {
  margin-top: 48px !important;
}

.mb-12 {
  margin-bottom: 48px !important;
}

.mx-12 {
  margin-left: 48px !important;
  margin-right: 48px !important;
}

.my-12 {
  margin-top: 48px !important;
  margin-bottom: 48px !important;
}

.ml-13 {
  margin-left: 52px !important;
}

.mr-13 {
  margin-right: 52px !important;
}

.mt-13 {
  margin-top: 52px !important;
}

.mb-13 {
  margin-bottom: 52px !important;
}

.mx-13 {
  margin-left: 52px !important;
  margin-right: 52px !important;
}

.my-13 {
  margin-top: 52px !important;
  margin-bottom: 52px !important;
}

.ml-14 {
  margin-left: 56px !important;
}

.mr-14 {
  margin-right: 56px !important;
}

.mt-14 {
  margin-top: 56px !important;
}

.mb-14 {
  margin-bottom: 56px !important;
}

.mx-14 {
  margin-left: 56px !important;
  margin-right: 56px !important;
}

.my-14 {
  margin-top: 56px !important;
  margin-bottom: 56px !important;
}

.ml-15 {
  margin-left: 60px !important;
}

.mr-15 {
  margin-right: 60px !important;
}

.mt-15 {
  margin-top: 60px !important;
}

.mb-15 {
  margin-bottom: 60px !important;
}

.mx-15 {
  margin-left: 60px !important;
  margin-right: 60px !important;
}

.my-15 {
  margin-top: 60px !important;
  margin-bottom: 60px !important;
}

.ml-16 {
  margin-left: 64px !important;
}

.mr-16 {
  margin-right: 64px !important;
}

.mt-16 {
  margin-top: 64px !important;
}

.mb-16 {
  margin-bottom: 64px !important;
}

.mx-16 {
  margin-left: 64px !important;
  margin-right: 64px !important;
}

.my-16 {
  margin-top: 64px !important;
  margin-bottom: 64px !important;
}

.ml-17 {
  margin-left: 68px !important;
}

.mr-17 {
  margin-right: 68px !important;
}

.mt-17 {
  margin-top: 68px !important;
}

.mb-17 {
  margin-bottom: 68px !important;
}

.mx-17 {
  margin-left: 68px !important;
  margin-right: 68px !important;
}

.my-17 {
  margin-top: 68px !important;
  margin-bottom: 68px !important;
}

.ml-18 {
  margin-left: 72px !important;
}

.mr-18 {
  margin-right: 72px !important;
}

.mt-18 {
  margin-top: 72px !important;
}

.mb-18 {
  margin-bottom: 72px !important;
}

.mx-18 {
  margin-left: 72px !important;
  margin-right: 72px !important;
}

.my-18 {
  margin-top: 72px !important;
  margin-bottom: 72px !important;
}

.ml-19 {
  margin-left: 76px !important;
}

.mr-19 {
  margin-right: 76px !important;
}

.mt-19 {
  margin-top: 76px !important;
}

.mb-19 {
  margin-bottom: 76px !important;
}

.mx-19 {
  margin-left: 76px !important;
  margin-right: 76px !important;
}

.my-19 {
  margin-top: 76px !important;
  margin-bottom: 76px !important;
}

.pl-0 {
  padding-left: 0px !important;
}

.pr-0 {
  padding-right: 0px !important;
}

.pt-0 {
  padding-top: 0px !important;
}

.pb-0 {
  padding-bottom: 0px !important;
}

.px-0 {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.py-0 {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.pl-1 {
  padding-left: 4px !important;
}

.pr-1 {
  padding-right: 4px !important;
}

.pt-1 {
  padding-top: 4px !important;
}

.pb-1 {
  padding-bottom: 4px !important;
}

.px-1 {
  padding-left: 4px !important;
  padding-right: 4px !important;
}

.py-1 {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}

.pl-2 {
  padding-left: 8px !important;
}

.pr-2 {
  padding-right: 8px !important;
}

.pt-2 {
  padding-top: 8px !important;
}

.pb-2 {
  padding-bottom: 8px !important;
}

.px-2 {
  padding-left: 8px !important;
  padding-right: 8px !important;
}

.py-2 {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

.pl-3 {
  padding-left: 12px !important;
}

.pr-3 {
  padding-right: 12px !important;
}

.pt-3 {
  padding-top: 12px !important;
}

.pb-3 {
  padding-bottom: 12px !important;
}

.px-3 {
  padding-left: 12px !important;
  padding-right: 12px !important;
}

.py-3 {
  padding-top: 12px !important;
  padding-bottom: 12px !important;
}

.pl-4 {
  padding-left: 16px !important;
}

.pr-4 {
  padding-right: 16px !important;
}

.pt-4 {
  padding-top: 16px !important;
}

.pb-4 {
  padding-bottom: 16px !important;
}

.px-4 {
  padding-left: 16px !important;
  padding-right: 16px !important;
}

.py-4 {
  padding-top: 16px !important;
  padding-bottom: 16px !important;
}

.pl-5 {
  padding-left: 20px !important;
}

.pr-5 {
  padding-right: 20px !important;
}

.pt-5 {
  padding-top: 20px !important;
}

.pb-5 {
  padding-bottom: 20px !important;
}

.px-5 {
  padding-left: 20px !important;
  padding-right: 20px !important;
}

.py-5 {
  padding-top: 20px !important;
  padding-bottom: 20px !important;
}

.pl-6 {
  padding-left: 24px !important;
}

.pr-6 {
  padding-right: 24px !important;
}

.pt-6 {
  padding-top: 24px !important;
}

.pb-6 {
  padding-bottom: 24px !important;
}

.px-6 {
  padding-left: 24px !important;
  padding-right: 24px !important;
}

.py-6 {
  padding-top: 24px !important;
  padding-bottom: 24px !important;
}

.pl-7 {
  padding-left: 28px !important;
}

.pr-7 {
  padding-right: 28px !important;
}

.pt-7 {
  padding-top: 28px !important;
}

.pb-7 {
  padding-bottom: 28px !important;
}

.px-7 {
  padding-left: 28px !important;
  padding-right: 28px !important;
}

.py-7 {
  padding-top: 28px !important;
  padding-bottom: 28px !important;
}

.pl-8 {
  padding-left: 32px !important;
}

.pr-8 {
  padding-right: 32px !important;
}

.pt-8 {
  padding-top: 32px !important;
}

.pb-8 {
  padding-bottom: 32px !important;
}

.px-8 {
  padding-left: 32px !important;
  padding-right: 32px !important;
}

.py-8 {
  padding-top: 32px !important;
  padding-bottom: 32px !important;
}

.pl-9 {
  padding-left: 36px !important;
}

.pr-9 {
  padding-right: 36px !important;
}

.pt-9 {
  padding-top: 36px !important;
}

.pb-9 {
  padding-bottom: 36px !important;
}

.px-9 {
  padding-left: 36px !important;
  padding-right: 36px !important;
}

.py-9 {
  padding-top: 36px !important;
  padding-bottom: 36px !important;
}

.pl-10 {
  padding-left: 40px !important;
}

.pr-10 {
  padding-right: 40px !important;
}

.pt-10 {
  padding-top: 40px !important;
}

.pb-10 {
  padding-bottom: 40px !important;
}

.px-10 {
  padding-left: 40px !important;
  padding-right: 40px !important;
}

.py-10 {
  padding-top: 40px !important;
  padding-bottom: 40px !important;
}

.pl-11 {
  padding-left: 44px !important;
}

.pr-11 {
  padding-right: 44px !important;
}

.pt-11 {
  padding-top: 44px !important;
}

.pb-11 {
  padding-bottom: 44px !important;
}

.px-11 {
  padding-left: 44px !important;
  padding-right: 44px !important;
}

.py-11 {
  padding-top: 44px !important;
  padding-bottom: 44px !important;
}

.pl-12 {
  padding-left: 48px !important;
}

.pr-12 {
  padding-right: 48px !important;
}

.pt-12 {
  padding-top: 48px !important;
}

.pb-12 {
  padding-bottom: 48px !important;
}

.px-12 {
  padding-left: 48px !important;
  padding-right: 48px !important;
}

.py-12 {
  padding-top: 48px !important;
  padding-bottom: 48px !important;
}

.pl-13 {
  padding-left: 52px !important;
}

.pr-13 {
  padding-right: 52px !important;
}

.pt-13 {
  padding-top: 52px !important;
}

.pb-13 {
  padding-bottom: 52px !important;
}

.px-13 {
  padding-left: 52px !important;
  padding-right: 52px !important;
}

.py-13 {
  padding-top: 52px !important;
  padding-bottom: 52px !important;
}

.pl-14 {
  padding-left: 56px !important;
}

.pr-14 {
  padding-right: 56px !important;
}

.pt-14 {
  padding-top: 56px !important;
}

.pb-14 {
  padding-bottom: 56px !important;
}

.px-14 {
  padding-left: 56px !important;
  padding-right: 56px !important;
}

.py-14 {
  padding-top: 56px !important;
  padding-bottom: 56px !important;
}

.pl-15 {
  padding-left: 60px !important;
}

.pr-15 {
  padding-right: 60px !important;
}

.pt-15 {
  padding-top: 60px !important;
}

.pb-15 {
  padding-bottom: 60px !important;
}

.px-15 {
  padding-left: 60px !important;
  padding-right: 60px !important;
}

.py-15 {
  padding-top: 60px !important;
  padding-bottom: 60px !important;
}

.pl-16 {
  padding-left: 64px !important;
}

.pr-16 {
  padding-right: 64px !important;
}

.pt-16 {
  padding-top: 64px !important;
}

.pb-16 {
  padding-bottom: 64px !important;
}

.px-16 {
  padding-left: 64px !important;
  padding-right: 64px !important;
}

.py-16 {
  padding-top: 64px !important;
  padding-bottom: 64px !important;
}

.pl-17 {
  padding-left: 68px !important;
}

.pr-17 {
  padding-right: 68px !important;
}

.pt-17 {
  padding-top: 68px !important;
}

.pb-17 {
  padding-bottom: 68px !important;
}

.px-17 {
  padding-left: 68px !important;
  padding-right: 68px !important;
}

.py-17 {
  padding-top: 68px !important;
  padding-bottom: 68px !important;
}

.pl-18 {
  padding-left: 72px !important;
}

.pr-18 {
  padding-right: 72px !important;
}

.pt-18 {
  padding-top: 72px !important;
}

.pb-18 {
  padding-bottom: 72px !important;
}

.px-18 {
  padding-left: 72px !important;
  padding-right: 72px !important;
}

.py-18 {
  padding-top: 72px !important;
  padding-bottom: 72px !important;
}

.pl-19 {
  padding-left: 76px !important;
}

.pr-19 {
  padding-right: 76px !important;
}

.pt-19 {
  padding-top: 76px !important;
}

.pb-19 {
  padding-bottom: 76px !important;
}

.px-19 {
  padding-left: 76px !important;
  padding-right: 76px !important;
}

.py-19 {
  padding-top: 76px !important;
  padding-bottom: 76px !important;
}

.Navbar {
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 99;
  width: 100%;
  padding: 16px 0px;
  min-height: 156px;
  background: #E9F1FD;
}
.Navbar.box-shadow {
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
}
.Navbar .row {
  max-width: 1800px;
}
.Navbar .nav-section ul {
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 20px;
}
.Navbar .nav-section ul li .nav-link {
  text-decoration: none;
  font-size: 0.875rem;
  color: #000000;
  cursor: pointer;
  display: inline-block;
}
.Navbar .nav-section ul li .nav-link:hover {
  color: #1E2E5F;
}
.Navbar .nav-section ul li .nav-link.product-link {
  text-transform: capitalize;
  font-family: "poppins";
  color: #000000;
  padding: 0px 16px 0px 0px;
  min-height: 10px;
  font-weight: 400;
  position: relative;
  line-height: 21px;
}
.Navbar .nav-section ul li .nav-link.product-link:before {
  position: absolute;
  top: 8px;
  right: 0;
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 0 0/10px;
  height: 7px;
  width: 10px;
}
.Navbar .nav-section ul li .nav-link.product-link:hover {
  color: #1E2E5F;
  background: none;
  transition: none;
}
.Navbar .nav-section ul li .nav-link.product-link:focus, .Navbar .nav-section ul li .nav-link.product-link:active {
  background: none;
  transition: none;
}
.Navbar .nav-section ul li .ca-link {
  text-decoration: none;
  font-size: 0.875rem;
  line-height: 21px;
  color: #ffffff;
  display: inline-block;
  padding: 8px 16px;
  border-radius: 30px;
  position: relative;
  background: #BE2532;
}
.Navbar .nav-section ul li .ca-link:hover {
  color: #ffffff;
}
.Navbar .nav-section ul li .ca-link span {
  position: absolute;
  top: -8px;
  right: 12px;
  border-radius: 30px;
  background: #F8E007;
  color: #000000;
  padding: 2px 8px;
  display: inline;
}
.Navbar .nav-section ul li .ca-link span p {
  font-size: 0.5625rem;
  font-weight: 600;
  line-height: 10px;
}
.Navbar .nav-section ul li .ca-link span .blink_text {
  animation-name: blinker;
  animation-duration: 1s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}
.Navbar .nav-section ul li .ca-link span.boxblink {
  animation-name: boxblinker;
  animation-duration: 1s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  transition: all ease-in-out 1s;
}
@keyframes blinker {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.1;
  }
  100% {
    opacity: 1;
  }
}
@keyframes boxblinker {
  0% {
    scale: 1;
  }
  50% {
    scale: 0.8;
  }
  100% {
    scale: 1;
  }
}
.Navbar .nav-section ul li .pir-link {
  background: #1E2E5F;
  text-decoration: none;
  font-size: 0.875rem;
  line-height: 21px;
  color: #ffffff;
  display: inline-block;
  padding: 8px 16px;
  border-radius: 30px;
  border: none;
}
.Navbar .nav-section ul li .pir-link:hover {
  color: #ffffff;
}
.Navbar .nav-section ul li .login {
  text-decoration: none;
  font-size: 0.875rem;
  line-height: 21px;
  color: #ffffff;
  display: inline-block;
  padding: 8px 16px;
  border-radius: 30px;
  position: relative;
  background: rgb(196, 61, 73);
}
.Navbar .nav-section ul li .login:hover {
  color: rgb(196, 61, 73);
  outline: 1px solid rgb(196, 61, 73);
  outline-offset: -1px;
  background: transparent;
}
.Navbar .nav-section ul li .logo-link {
  text-decoration: none;
  font-size: 0.875rem;
  line-height: 21px;
  color: #ffffff;
  display: inline-flex;
  padding: 6px 16px;
  border-radius: 30px;
  position: relative;
  outline: 1px solid #1E2E5F;
  outline-offset: -1px;
}
.Navbar .nav-section ul li .logo-link img {
  height: 25px;
}
.Navbar .nav-section.ns2 ul {
  gap: 15px;
}
.Navbar .rounded {
  border-radius: 100px !important;
  box-shadow: 0px 6px 7px 0px rgba(0, 181, 135, 0.2) !important;
}
.Navbar .mutilevel button {
  background-color: transparent !important;
  padding: 0 !important;
  height: 20px !important;
  font-weight: 400 !important;
  color: #000000 !important;
  font-size: 14px !important;
  letter-spacing: 0 !important;
}
.Navbar .mutilevel .dropdown {
  min-width: 240px !important;
}
.Navbar .mutilevel .dropdown ul {
  flex-direction: column !important;
  align-items: start !important;
  gap: 4px !important;
  margin: 12px !important;
}
.Navbar .mutilevel .dropdown ul li {
  padding: 4px 8px !important;
  width: 100% !important;
  color: #000000;
  white-space: wrap !important;
  display: block;
  text-align: left;
  font-size: 13px !important;
}
.Navbar .mutilevel .dropdown ul li:hover {
  color: #1E2E5F;
}
.Navbar .mutilevel .dropdown ul li .submenu {
  min-width: 200px !important;
}
.Navbar .mutilevel .dropdown ul li .submenu ul {
  gap: 2px !important;
}
.Navbar .mutilevel .dropdown ul li .submenu ul .submenu-item {
  font-size: 12px !important;
  line-height: 18px !important;
  white-space: wrap !important;
  display: block !important;
  text-align: left !important;
  list-style-type: disc;
  padding: 4px 2px;
}

*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/*! tailwindcss v3.4.14 | MIT License | https://tailwindcss.com*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.container{
  width: 100%;
}
@media (min-width: 640px){
  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){
  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){
  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1280px){
  .container{
    max-width: 1280px;
  }
}
@media (min-width: 1536px){
  .container{
    max-width: 1536px;
  }
}
.collapse{
  visibility: collapse;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.m-auto{
  margin: auto;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-10{
  margin-bottom: 2.5rem;
}
.mb-12{
  margin-bottom: 3rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-20{
  margin-bottom: 5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-7{
  margin-top: 1.75rem;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.table{
  display: table;
}
.contents{
  display: contents;
}
.hidden{
  display: none;
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.resize{
  resize: both;
}
.border{
  border-width: 1px;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.uppercase{
  text-transform: uppercase;
}
.outline{
  outline-style: solid;
}
.blur{
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
* {
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
  text-rendering: auto;
  text-rendering: optimizeSpeed;
  text-rendering: optimizeLegibility;
  text-rendering: geometricPrecision;
  font-synthesis: none;
  -moz-font-feature-settings: "kern";
  -moz-osx-font-smoothing: grayscale;
}

html {
  scroll-behavior: smooth;
}

body {
  background-color: #ffffff;
  font-family: "Poppins", sans-serif;
  height: 100%;
  margin: 0px;
  padding: 0px;
  font-size: 1rem;
  overflow-x: hidden;
  font-smooth: always;
  font-smoothing: antialiased;
  -moz-font-smoothing: antialiased;
  -webkit-font-smoothing: antialiased;
  text-size-adjust: none;
  -webkit-text-size-adjust: none;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
}

h1 {
  font-size: 50px;
  line-height: 75px;
  font-weight: 600;
}
@media (max-width: 899px) {
  h1 {
    font-size: 40px;
    line-height: 60px;
  }
}
@media (max-width: 599px) {
  h1 {
    font-size: 36px;
    line-height: 54px;
  }
}

h2 {
  font-size: 2.5rem;
  font-weight: 600;
  line-height: 60px;
}

h3 {
  font-size: 2rem;
  font-weight: 600;
  line-height: 42px;
}

h4 {
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 36px;
}

h5 {
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 30px;
}

h6 {
  font-size: 1rem;
  font-weight: 600;
  line-height: 24px;
}

p {
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 21px;
  color: rgb(89, 89, 89);
}

img {
  vertical-align: middle;
}

ul {
  margin: 0;
  padding: 0;
}
ul li {
  list-style: none;
}

.row {
  max-width: 1224px;
  width: 100%;
  margin-left: auto !important;
  margin-right: auto !important;
}

.MuiGrid2-container {
  width: 100%;
  margin-left: auto !important;
  margin-right: auto !important;
}

a {
  cursor: pointer;
  text-decoration: none !important;
}`, "",{"version":3,"sources":["webpack://./src/SCSS/Mixins.scss","webpack://./src/index.scss","webpack://./src/Components/Desktop/Navbar/Navbar.scss"],"names":[],"mappings":"AAWA,yCAAA;AAoDI;EACI,2BAAA;AC5DR;;AD+DI;EACI,4BAAA;AC5DR;;AD+DI;EACI,0BAAA;AC5DR;;AD+DI;EACI,6BAAA;AC5DR;;AD+DI;EACI,2BAAA;EACA,4BAAA;AC5DR;;AD+DI;EACI,0BAAA;EACA,6BAAA;AC5DR;;ADqCI;EACI,2BAAA;AClCR;;ADqCI;EACI,4BAAA;AClCR;;ADqCI;EACI,0BAAA;AClCR;;ADqCI;EACI,6BAAA;AClCR;;ADqCI;EACI,2BAAA;EACA,4BAAA;AClCR;;ADqCI;EACI,0BAAA;EACA,6BAAA;AClCR;;ADWI;EACI,2BAAA;ACRR;;ADWI;EACI,4BAAA;ACRR;;ADWI;EACI,0BAAA;ACRR;;ADWI;EACI,6BAAA;ACRR;;ADWI;EACI,2BAAA;EACA,4BAAA;ACRR;;ADWI;EACI,0BAAA;EACA,6BAAA;ACRR;;ADfI;EACI,4BAAA;ACkBR;;ADfI;EACI,6BAAA;ACkBR;;ADfI;EACI,2BAAA;ACkBR;;ADfI;EACI,8BAAA;ACkBR;;ADfI;EACI,4BAAA;EACA,6BAAA;ACkBR;;ADfI;EACI,2BAAA;EACA,8BAAA;ACkBR;;ADzCI;EACI,4BAAA;AC4CR;;ADzCI;EACI,6BAAA;AC4CR;;ADzCI;EACI,2BAAA;AC4CR;;ADzCI;EACI,8BAAA;AC4CR;;ADzCI;EACI,4BAAA;EACA,6BAAA;AC4CR;;ADzCI;EACI,2BAAA;EACA,8BAAA;AC4CR;;ADnEI;EACI,4BAAA;ACsER;;ADnEI;EACI,6BAAA;ACsER;;ADnEI;EACI,2BAAA;ACsER;;ADnEI;EACI,8BAAA;ACsER;;ADnEI;EACI,4BAAA;EACA,6BAAA;ACsER;;ADnEI;EACI,2BAAA;EACA,8BAAA;ACsER;;AD7FI;EACI,4BAAA;ACgGR;;AD7FI;EACI,6BAAA;ACgGR;;AD7FI;EACI,2BAAA;ACgGR;;AD7FI;EACI,8BAAA;ACgGR;;AD7FI;EACI,4BAAA;EACA,6BAAA;ACgGR;;AD7FI;EACI,2BAAA;EACA,8BAAA;ACgGR;;ADvHI;EACI,4BAAA;AC0HR;;ADvHI;EACI,6BAAA;AC0HR;;ADvHI;EACI,2BAAA;AC0HR;;ADvHI;EACI,8BAAA;AC0HR;;ADvHI;EACI,4BAAA;EACA,6BAAA;AC0HR;;ADvHI;EACI,2BAAA;EACA,8BAAA;AC0HR;;ADjJI;EACI,4BAAA;ACoJR;;ADjJI;EACI,6BAAA;ACoJR;;ADjJI;EACI,2BAAA;ACoJR;;ADjJI;EACI,8BAAA;ACoJR;;ADjJI;EACI,4BAAA;EACA,6BAAA;ACoJR;;ADjJI;EACI,2BAAA;EACA,8BAAA;ACoJR;;AD3KI;EACI,4BAAA;AC8KR;;AD3KI;EACI,6BAAA;AC8KR;;AD3KI;EACI,2BAAA;AC8KR;;AD3KI;EACI,8BAAA;AC8KR;;AD3KI;EACI,4BAAA;EACA,6BAAA;AC8KR;;AD3KI;EACI,2BAAA;EACA,8BAAA;AC8KR;;ADrMI;EACI,4BAAA;ACwMR;;ADrMI;EACI,6BAAA;ACwMR;;ADrMI;EACI,2BAAA;ACwMR;;ADrMI;EACI,8BAAA;ACwMR;;ADrMI;EACI,4BAAA;EACA,6BAAA;ACwMR;;ADrMI;EACI,2BAAA;EACA,8BAAA;ACwMR;;AD/NI;EACI,4BAAA;ACkOR;;AD/NI;EACI,6BAAA;ACkOR;;AD/NI;EACI,2BAAA;ACkOR;;AD/NI;EACI,8BAAA;ACkOR;;AD/NI;EACI,4BAAA;EACA,6BAAA;ACkOR;;AD/NI;EACI,2BAAA;EACA,8BAAA;ACkOR;;ADzPI;EACI,4BAAA;AC4PR;;ADzPI;EACI,6BAAA;AC4PR;;ADzPI;EACI,2BAAA;AC4PR;;ADzPI;EACI,8BAAA;AC4PR;;ADzPI;EACI,4BAAA;EACA,6BAAA;AC4PR;;ADzPI;EACI,2BAAA;EACA,8BAAA;AC4PR;;ADnRI;EACI,4BAAA;ACsRR;;ADnRI;EACI,6BAAA;ACsRR;;ADnRI;EACI,2BAAA;ACsRR;;ADnRI;EACI,8BAAA;ACsRR;;ADnRI;EACI,4BAAA;EACA,6BAAA;ACsRR;;ADnRI;EACI,2BAAA;EACA,8BAAA;ACsRR;;AD7SI;EACI,4BAAA;ACgTR;;AD7SI;EACI,6BAAA;ACgTR;;AD7SI;EACI,2BAAA;ACgTR;;AD7SI;EACI,8BAAA;ACgTR;;AD7SI;EACI,4BAAA;EACA,6BAAA;ACgTR;;AD7SI;EACI,2BAAA;EACA,8BAAA;ACgTR;;ADvUI;EACI,4BAAA;AC0UR;;ADvUI;EACI,6BAAA;AC0UR;;ADvUI;EACI,2BAAA;AC0UR;;ADvUI;EACI,8BAAA;AC0UR;;ADvUI;EACI,4BAAA;EACA,6BAAA;AC0UR;;ADvUI;EACI,2BAAA;EACA,8BAAA;AC0UR;;ADjWI;EACI,4BAAA;ACoWR;;ADjWI;EACI,6BAAA;ACoWR;;ADjWI;EACI,2BAAA;ACoWR;;ADjWI;EACI,8BAAA;ACoWR;;ADjWI;EACI,4BAAA;EACA,6BAAA;ACoWR;;ADjWI;EACI,2BAAA;EACA,8BAAA;ACoWR;;AD3XI;EACI,4BAAA;AC8XR;;AD3XI;EACI,6BAAA;AC8XR;;AD3XI;EACI,2BAAA;AC8XR;;AD3XI;EACI,8BAAA;AC8XR;;AD3XI;EACI,4BAAA;EACA,6BAAA;AC8XR;;AD3XI;EACI,2BAAA;EACA,8BAAA;AC8XR;;ADrZI;EACI,4BAAA;ACwZR;;ADrZI;EACI,6BAAA;ACwZR;;ADrZI;EACI,2BAAA;ACwZR;;ADrZI;EACI,8BAAA;ACwZR;;ADrZI;EACI,4BAAA;EACA,6BAAA;ACwZR;;ADrZI;EACI,2BAAA;EACA,8BAAA;ACwZR;;AD/aI;EACI,4BAAA;ACkbR;;AD/aI;EACI,6BAAA;ACkbR;;AD/aI;EACI,2BAAA;ACkbR;;AD/aI;EACI,8BAAA;ACkbR;;AD/aI;EACI,4BAAA;EACA,6BAAA;ACkbR;;AD/aI;EACI,2BAAA;EACA,8BAAA;ACkbR;;AD5aI;EACI,4BAAA;AC+aR;;AD5aI;EACI,6BAAA;AC+aR;;AD5aI;EACI,2BAAA;AC+aR;;AD5aI;EACI,8BAAA;AC+aR;;AD5aI;EACI,4BAAA;EACA,6BAAA;AC+aR;;AD5aI;EACI,2BAAA;EACA,8BAAA;AC+aR;;ADtcI;EACI,4BAAA;ACycR;;ADtcI;EACI,6BAAA;ACycR;;ADtcI;EACI,2BAAA;ACycR;;ADtcI;EACI,8BAAA;ACycR;;ADtcI;EACI,4BAAA;EACA,6BAAA;ACycR;;ADtcI;EACI,2BAAA;EACA,8BAAA;ACycR;;ADheI;EACI,4BAAA;ACmeR;;ADheI;EACI,6BAAA;ACmeR;;ADheI;EACI,2BAAA;ACmeR;;ADheI;EACI,8BAAA;ACmeR;;ADheI;EACI,4BAAA;EACA,6BAAA;ACmeR;;ADheI;EACI,2BAAA;EACA,8BAAA;ACmeR;;AD1fI;EACI,6BAAA;AC6fR;;AD1fI;EACI,8BAAA;AC6fR;;AD1fI;EACI,4BAAA;AC6fR;;AD1fI;EACI,+BAAA;AC6fR;;AD1fI;EACI,6BAAA;EACA,8BAAA;AC6fR;;AD1fI;EACI,4BAAA;EACA,+BAAA;AC6fR;;ADphBI;EACI,6BAAA;ACuhBR;;ADphBI;EACI,8BAAA;ACuhBR;;ADphBI;EACI,4BAAA;ACuhBR;;ADphBI;EACI,+BAAA;ACuhBR;;ADphBI;EACI,6BAAA;EACA,8BAAA;ACuhBR;;ADphBI;EACI,4BAAA;EACA,+BAAA;ACuhBR;;AD9iBI;EACI,6BAAA;ACijBR;;AD9iBI;EACI,8BAAA;ACijBR;;AD9iBI;EACI,4BAAA;ACijBR;;AD9iBI;EACI,+BAAA;ACijBR;;AD9iBI;EACI,6BAAA;EACA,8BAAA;ACijBR;;AD9iBI;EACI,4BAAA;EACA,+BAAA;ACijBR;;ADxkBI;EACI,6BAAA;AC2kBR;;ADxkBI;EACI,8BAAA;AC2kBR;;ADxkBI;EACI,4BAAA;AC2kBR;;ADxkBI;EACI,+BAAA;AC2kBR;;ADxkBI;EACI,6BAAA;EACA,8BAAA;AC2kBR;;ADxkBI;EACI,4BAAA;EACA,+BAAA;AC2kBR;;ADlmBI;EACI,6BAAA;ACqmBR;;ADlmBI;EACI,8BAAA;ACqmBR;;ADlmBI;EACI,4BAAA;ACqmBR;;ADlmBI;EACI,+BAAA;ACqmBR;;ADlmBI;EACI,6BAAA;EACA,8BAAA;ACqmBR;;ADlmBI;EACI,4BAAA;EACA,+BAAA;ACqmBR;;AD5nBI;EACI,6BAAA;AC+nBR;;AD5nBI;EACI,8BAAA;AC+nBR;;AD5nBI;EACI,4BAAA;AC+nBR;;AD5nBI;EACI,+BAAA;AC+nBR;;AD5nBI;EACI,6BAAA;EACA,8BAAA;AC+nBR;;AD5nBI;EACI,4BAAA;EACA,+BAAA;AC+nBR;;ADtpBI;EACI,6BAAA;ACypBR;;ADtpBI;EACI,8BAAA;ACypBR;;ADtpBI;EACI,4BAAA;ACypBR;;ADtpBI;EACI,+BAAA;ACypBR;;ADtpBI;EACI,6BAAA;EACA,8BAAA;ACypBR;;ADtpBI;EACI,4BAAA;EACA,+BAAA;ACypBR;;ADhrBI;EACI,6BAAA;ACmrBR;;ADhrBI;EACI,8BAAA;ACmrBR;;ADhrBI;EACI,4BAAA;ACmrBR;;ADhrBI;EACI,+BAAA;ACmrBR;;ADhrBI;EACI,6BAAA;EACA,8BAAA;ACmrBR;;ADhrBI;EACI,4BAAA;EACA,+BAAA;ACmrBR;;AD1sBI;EACI,6BAAA;AC6sBR;;AD1sBI;EACI,8BAAA;AC6sBR;;AD1sBI;EACI,4BAAA;AC6sBR;;AD1sBI;EACI,+BAAA;AC6sBR;;AD1sBI;EACI,6BAAA;EACA,8BAAA;AC6sBR;;AD1sBI;EACI,4BAAA;EACA,+BAAA;AC6sBR;;ADpuBI;EACI,6BAAA;ACuuBR;;ADpuBI;EACI,8BAAA;ACuuBR;;ADpuBI;EACI,4BAAA;ACuuBR;;ADpuBI;EACI,+BAAA;ACuuBR;;ADpuBI;EACI,6BAAA;EACA,8BAAA;ACuuBR;;ADpuBI;EACI,4BAAA;EACA,+BAAA;ACuuBR;;AD9vBI;EACI,6BAAA;ACiwBR;;AD9vBI;EACI,8BAAA;ACiwBR;;AD9vBI;EACI,4BAAA;ACiwBR;;AD9vBI;EACI,+BAAA;ACiwBR;;AD9vBI;EACI,6BAAA;EACA,8BAAA;ACiwBR;;AD9vBI;EACI,4BAAA;EACA,+BAAA;ACiwBR;;ADxxBI;EACI,6BAAA;AC2xBR;;ADxxBI;EACI,8BAAA;AC2xBR;;ADxxBI;EACI,4BAAA;AC2xBR;;ADxxBI;EACI,+BAAA;AC2xBR;;ADxxBI;EACI,6BAAA;EACA,8BAAA;AC2xBR;;ADxxBI;EACI,4BAAA;EACA,+BAAA;AC2xBR;;ADlzBI;EACI,6BAAA;ACqzBR;;ADlzBI;EACI,8BAAA;ACqzBR;;ADlzBI;EACI,4BAAA;ACqzBR;;ADlzBI;EACI,+BAAA;ACqzBR;;ADlzBI;EACI,6BAAA;EACA,8BAAA;ACqzBR;;ADlzBI;EACI,4BAAA;EACA,+BAAA;ACqzBR;;AD50BI;EACI,6BAAA;AC+0BR;;AD50BI;EACI,8BAAA;AC+0BR;;AD50BI;EACI,4BAAA;AC+0BR;;AD50BI;EACI,+BAAA;AC+0BR;;AD50BI;EACI,6BAAA;EACA,8BAAA;AC+0BR;;AD50BI;EACI,4BAAA;EACA,+BAAA;AC+0BR;;ADt2BI;EACI,6BAAA;ACy2BR;;ADt2BI;EACI,8BAAA;ACy2BR;;ADt2BI;EACI,4BAAA;ACy2BR;;ADt2BI;EACI,+BAAA;ACy2BR;;ADt2BI;EACI,6BAAA;EACA,8BAAA;ACy2BR;;ADt2BI;EACI,4BAAA;EACA,+BAAA;ACy2BR;;ADh4BI;EACI,6BAAA;ACm4BR;;ADh4BI;EACI,8BAAA;ACm4BR;;ADh4BI;EACI,4BAAA;ACm4BR;;ADh4BI;EACI,+BAAA;ACm4BR;;ADh4BI;EACI,6BAAA;EACA,8BAAA;ACm4BR;;ADh4BI;EACI,4BAAA;EACA,+BAAA;ACm4BR;;AD15BI;EACI,6BAAA;AC65BR;;AD15BI;EACI,8BAAA;AC65BR;;AD15BI;EACI,4BAAA;AC65BR;;AD15BI;EACI,+BAAA;AC65BR;;AD15BI;EACI,6BAAA;EACA,8BAAA;AC65BR;;AD15BI;EACI,4BAAA;EACA,+BAAA;AC65BR;;ADrgCA,yCAAA;AAoDI;EACI,2BAAA;ACq9BR;;ADl9BI;EACI,4BAAA;ACq9BR;;ADl9BI;EACI,0BAAA;ACq9BR;;ADl9BI;EACI,6BAAA;ACq9BR;;ADl9BI;EACI,2BAAA;EACA,4BAAA;ACq9BR;;ADl9BI;EACI,0BAAA;EACA,6BAAA;ACq9BR;;AD5+BI;EACI,2BAAA;AC++BR;;AD5+BI;EACI,4BAAA;AC++BR;;AD5+BI;EACI,0BAAA;AC++BR;;AD5+BI;EACI,6BAAA;AC++BR;;AD5+BI;EACI,2BAAA;EACA,4BAAA;AC++BR;;AD5+BI;EACI,0BAAA;EACA,6BAAA;AC++BR;;ADtgCI;EACI,2BAAA;ACygCR;;ADtgCI;EACI,4BAAA;ACygCR;;ADtgCI;EACI,0BAAA;ACygCR;;ADtgCI;EACI,6BAAA;ACygCR;;ADtgCI;EACI,2BAAA;EACA,4BAAA;ACygCR;;ADtgCI;EACI,0BAAA;EACA,6BAAA;ACygCR;;ADhiCI;EACI,4BAAA;ACmiCR;;ADhiCI;EACI,6BAAA;ACmiCR;;ADhiCI;EACI,2BAAA;ACmiCR;;ADhiCI;EACI,8BAAA;ACmiCR;;ADhiCI;EACI,4BAAA;EACA,6BAAA;ACmiCR;;ADhiCI;EACI,2BAAA;EACA,8BAAA;ACmiCR;;AD1jCI;EACI,4BAAA;AC6jCR;;AD1jCI;EACI,6BAAA;AC6jCR;;AD1jCI;EACI,2BAAA;AC6jCR;;AD1jCI;EACI,8BAAA;AC6jCR;;AD1jCI;EACI,4BAAA;EACA,6BAAA;AC6jCR;;AD1jCI;EACI,2BAAA;EACA,8BAAA;AC6jCR;;ADplCI;EACI,4BAAA;ACulCR;;ADplCI;EACI,6BAAA;ACulCR;;ADplCI;EACI,2BAAA;ACulCR;;ADplCI;EACI,8BAAA;ACulCR;;ADplCI;EACI,4BAAA;EACA,6BAAA;ACulCR;;ADplCI;EACI,2BAAA;EACA,8BAAA;ACulCR;;AD9mCI;EACI,4BAAA;ACinCR;;AD9mCI;EACI,6BAAA;ACinCR;;AD9mCI;EACI,2BAAA;ACinCR;;AD9mCI;EACI,8BAAA;ACinCR;;AD9mCI;EACI,4BAAA;EACA,6BAAA;ACinCR;;AD9mCI;EACI,2BAAA;EACA,8BAAA;ACinCR;;ADxoCI;EACI,4BAAA;AC2oCR;;ADxoCI;EACI,6BAAA;AC2oCR;;ADxoCI;EACI,2BAAA;AC2oCR;;ADxoCI;EACI,8BAAA;AC2oCR;;ADxoCI;EACI,4BAAA;EACA,6BAAA;AC2oCR;;ADxoCI;EACI,2BAAA;EACA,8BAAA;AC2oCR;;ADlqCI;EACI,4BAAA;ACqqCR;;ADlqCI;EACI,6BAAA;ACqqCR;;ADlqCI;EACI,2BAAA;ACqqCR;;ADlqCI;EACI,8BAAA;ACqqCR;;ADlqCI;EACI,4BAAA;EACA,6BAAA;ACqqCR;;ADlqCI;EACI,2BAAA;EACA,8BAAA;ACqqCR;;AD5rCI;EACI,4BAAA;AC+rCR;;AD5rCI;EACI,6BAAA;AC+rCR;;AD5rCI;EACI,2BAAA;AC+rCR;;AD5rCI;EACI,8BAAA;AC+rCR;;AD5rCI;EACI,4BAAA;EACA,6BAAA;AC+rCR;;AD5rCI;EACI,2BAAA;EACA,8BAAA;AC+rCR;;ADttCI;EACI,4BAAA;ACytCR;;ADttCI;EACI,6BAAA;ACytCR;;ADttCI;EACI,2BAAA;ACytCR;;ADttCI;EACI,8BAAA;ACytCR;;ADttCI;EACI,4BAAA;EACA,6BAAA;ACytCR;;ADttCI;EACI,2BAAA;EACA,8BAAA;ACytCR;;ADhvCI;EACI,4BAAA;ACmvCR;;ADhvCI;EACI,6BAAA;ACmvCR;;ADhvCI;EACI,2BAAA;ACmvCR;;ADhvCI;EACI,8BAAA;ACmvCR;;ADhvCI;EACI,4BAAA;EACA,6BAAA;ACmvCR;;ADhvCI;EACI,2BAAA;EACA,8BAAA;ACmvCR;;AD1wCI;EACI,4BAAA;AC6wCR;;AD1wCI;EACI,6BAAA;AC6wCR;;AD1wCI;EACI,2BAAA;AC6wCR;;AD1wCI;EACI,8BAAA;AC6wCR;;AD1wCI;EACI,4BAAA;EACA,6BAAA;AC6wCR;;AD1wCI;EACI,2BAAA;EACA,8BAAA;AC6wCR;;ADpyCI;EACI,4BAAA;ACuyCR;;ADpyCI;EACI,6BAAA;ACuyCR;;ADpyCI;EACI,2BAAA;ACuyCR;;ADpyCI;EACI,8BAAA;ACuyCR;;ADpyCI;EACI,4BAAA;EACA,6BAAA;ACuyCR;;ADpyCI;EACI,2BAAA;EACA,8BAAA;ACuyCR;;AD9zCI;EACI,4BAAA;ACi0CR;;AD9zCI;EACI,6BAAA;ACi0CR;;AD9zCI;EACI,2BAAA;ACi0CR;;AD9zCI;EACI,8BAAA;ACi0CR;;AD9zCI;EACI,4BAAA;EACA,6BAAA;ACi0CR;;AD9zCI;EACI,2BAAA;EACA,8BAAA;ACi0CR;;ADx1CI;EACI,4BAAA;AC21CR;;ADx1CI;EACI,6BAAA;AC21CR;;ADx1CI;EACI,2BAAA;AC21CR;;ADx1CI;EACI,8BAAA;AC21CR;;ADx1CI;EACI,4BAAA;EACA,6BAAA;AC21CR;;ADx1CI;EACI,2BAAA;EACA,8BAAA;AC21CR;;ADl3CI;EACI,4BAAA;ACq3CR;;ADl3CI;EACI,6BAAA;ACq3CR;;ADl3CI;EACI,2BAAA;ACq3CR;;ADl3CI;EACI,8BAAA;ACq3CR;;ADl3CI;EACI,4BAAA;EACA,6BAAA;ACq3CR;;ADl3CI;EACI,2BAAA;EACA,8BAAA;ACq3CR;;AD54CI;EACI,4BAAA;AC+4CR;;AD54CI;EACI,6BAAA;AC+4CR;;AD54CI;EACI,2BAAA;AC+4CR;;AD54CI;EACI,8BAAA;AC+4CR;;AD54CI;EACI,4BAAA;EACA,6BAAA;AC+4CR;;AD54CI;EACI,2BAAA;EACA,8BAAA;AC+4CR;;ADt6CI;EACI,4BAAA;ACy6CR;;ADt6CI;EACI,6BAAA;ACy6CR;;ADt6CI;EACI,2BAAA;ACy6CR;;ADt6CI;EACI,8BAAA;ACy6CR;;ADt6CI;EACI,4BAAA;EACA,6BAAA;ACy6CR;;ADt6CI;EACI,2BAAA;EACA,8BAAA;ACy6CR;;ADh8CI;EACI,4BAAA;ACm8CR;;ADh8CI;EACI,6BAAA;ACm8CR;;ADh8CI;EACI,2BAAA;ACm8CR;;ADh8CI;EACI,8BAAA;ACm8CR;;ADh8CI;EACI,4BAAA;EACA,6BAAA;ACm8CR;;ADh8CI;EACI,2BAAA;EACA,8BAAA;ACm8CR;;AD77CI;EACI,4BAAA;ACg8CR;;AD77CI;EACI,6BAAA;ACg8CR;;AD77CI;EACI,2BAAA;ACg8CR;;AD77CI;EACI,8BAAA;ACg8CR;;AD77CI;EACI,4BAAA;EACA,6BAAA;ACg8CR;;AD77CI;EACI,2BAAA;EACA,8BAAA;ACg8CR;;ADv9CI;EACI,4BAAA;AC09CR;;ADv9CI;EACI,6BAAA;AC09CR;;ADv9CI;EACI,2BAAA;AC09CR;;ADv9CI;EACI,8BAAA;AC09CR;;ADv9CI;EACI,4BAAA;EACA,6BAAA;AC09CR;;ADv9CI;EACI,2BAAA;EACA,8BAAA;AC09CR;;ADj/CI;EACI,4BAAA;ACo/CR;;ADj/CI;EACI,6BAAA;ACo/CR;;ADj/CI;EACI,2BAAA;ACo/CR;;ADj/CI;EACI,8BAAA;ACo/CR;;ADj/CI;EACI,4BAAA;EACA,6BAAA;ACo/CR;;ADj/CI;EACI,2BAAA;EACA,8BAAA;ACo/CR;;AD3gDI;EACI,6BAAA;AC8gDR;;AD3gDI;EACI,8BAAA;AC8gDR;;AD3gDI;EACI,4BAAA;AC8gDR;;AD3gDI;EACI,+BAAA;AC8gDR;;AD3gDI;EACI,6BAAA;EACA,8BAAA;AC8gDR;;AD3gDI;EACI,4BAAA;EACA,+BAAA;AC8gDR;;ADriDI;EACI,6BAAA;ACwiDR;;ADriDI;EACI,8BAAA;ACwiDR;;ADriDI;EACI,4BAAA;ACwiDR;;ADriDI;EACI,+BAAA;ACwiDR;;ADriDI;EACI,6BAAA;EACA,8BAAA;ACwiDR;;ADriDI;EACI,4BAAA;EACA,+BAAA;ACwiDR;;AD/jDI;EACI,6BAAA;ACkkDR;;AD/jDI;EACI,8BAAA;ACkkDR;;AD/jDI;EACI,4BAAA;ACkkDR;;AD/jDI;EACI,+BAAA;ACkkDR;;AD/jDI;EACI,6BAAA;EACA,8BAAA;ACkkDR;;AD/jDI;EACI,4BAAA;EACA,+BAAA;ACkkDR;;ADzlDI;EACI,6BAAA;AC4lDR;;ADzlDI;EACI,8BAAA;AC4lDR;;ADzlDI;EACI,4BAAA;AC4lDR;;ADzlDI;EACI,+BAAA;AC4lDR;;ADzlDI;EACI,6BAAA;EACA,8BAAA;AC4lDR;;ADzlDI;EACI,4BAAA;EACA,+BAAA;AC4lDR;;ADnnDI;EACI,6BAAA;ACsnDR;;ADnnDI;EACI,8BAAA;ACsnDR;;ADnnDI;EACI,4BAAA;ACsnDR;;ADnnDI;EACI,+BAAA;ACsnDR;;ADnnDI;EACI,6BAAA;EACA,8BAAA;ACsnDR;;ADnnDI;EACI,4BAAA;EACA,+BAAA;ACsnDR;;AD7oDI;EACI,6BAAA;ACgpDR;;AD7oDI;EACI,8BAAA;ACgpDR;;AD7oDI;EACI,4BAAA;ACgpDR;;AD7oDI;EACI,+BAAA;ACgpDR;;AD7oDI;EACI,6BAAA;EACA,8BAAA;ACgpDR;;AD7oDI;EACI,4BAAA;EACA,+BAAA;ACgpDR;;ADvqDI;EACI,6BAAA;AC0qDR;;ADvqDI;EACI,8BAAA;AC0qDR;;ADvqDI;EACI,4BAAA;AC0qDR;;ADvqDI;EACI,+BAAA;AC0qDR;;ADvqDI;EACI,6BAAA;EACA,8BAAA;AC0qDR;;ADvqDI;EACI,4BAAA;EACA,+BAAA;AC0qDR;;ADjsDI;EACI,6BAAA;ACosDR;;ADjsDI;EACI,8BAAA;ACosDR;;ADjsDI;EACI,4BAAA;ACosDR;;ADjsDI;EACI,+BAAA;ACosDR;;ADjsDI;EACI,6BAAA;EACA,8BAAA;ACosDR;;ADjsDI;EACI,4BAAA;EACA,+BAAA;ACosDR;;AD3tDI;EACI,6BAAA;AC8tDR;;AD3tDI;EACI,8BAAA;AC8tDR;;AD3tDI;EACI,4BAAA;AC8tDR;;AD3tDI;EACI,+BAAA;AC8tDR;;AD3tDI;EACI,6BAAA;EACA,8BAAA;AC8tDR;;AD3tDI;EACI,4BAAA;EACA,+BAAA;AC8tDR;;ADrvDI;EACI,6BAAA;ACwvDR;;ADrvDI;EACI,8BAAA;ACwvDR;;ADrvDI;EACI,4BAAA;ACwvDR;;ADrvDI;EACI,+BAAA;ACwvDR;;ADrvDI;EACI,6BAAA;EACA,8BAAA;ACwvDR;;ADrvDI;EACI,4BAAA;EACA,+BAAA;ACwvDR;;AD/wDI;EACI,6BAAA;ACkxDR;;AD/wDI;EACI,8BAAA;ACkxDR;;AD/wDI;EACI,4BAAA;ACkxDR;;AD/wDI;EACI,+BAAA;ACkxDR;;AD/wDI;EACI,6BAAA;EACA,8BAAA;ACkxDR;;AD/wDI;EACI,4BAAA;EACA,+BAAA;ACkxDR;;ADzyDI;EACI,6BAAA;AC4yDR;;ADzyDI;EACI,8BAAA;AC4yDR;;ADzyDI;EACI,4BAAA;AC4yDR;;ADzyDI;EACI,+BAAA;AC4yDR;;ADzyDI;EACI,6BAAA;EACA,8BAAA;AC4yDR;;ADzyDI;EACI,4BAAA;EACA,+BAAA;AC4yDR;;ADn0DI;EACI,6BAAA;ACs0DR;;ADn0DI;EACI,8BAAA;ACs0DR;;ADn0DI;EACI,4BAAA;ACs0DR;;ADn0DI;EACI,+BAAA;ACs0DR;;ADn0DI;EACI,6BAAA;EACA,8BAAA;ACs0DR;;ADn0DI;EACI,4BAAA;EACA,+BAAA;ACs0DR;;AD71DI;EACI,6BAAA;ACg2DR;;AD71DI;EACI,8BAAA;ACg2DR;;AD71DI;EACI,4BAAA;ACg2DR;;AD71DI;EACI,+BAAA;ACg2DR;;AD71DI;EACI,6BAAA;EACA,8BAAA;ACg2DR;;AD71DI;EACI,4BAAA;EACA,+BAAA;ACg2DR;;ADv3DI;EACI,6BAAA;AC03DR;;ADv3DI;EACI,8BAAA;AC03DR;;ADv3DI;EACI,4BAAA;AC03DR;;ADv3DI;EACI,+BAAA;AC03DR;;ADv3DI;EACI,6BAAA;EACA,8BAAA;AC03DR;;ADv3DI;EACI,4BAAA;EACA,+BAAA;AC03DR;;ADj5DI;EACI,6BAAA;ACo5DR;;ADj5DI;EACI,8BAAA;ACo5DR;;ADj5DI;EACI,4BAAA;ACo5DR;;ADj5DI;EACI,+BAAA;ACo5DR;;ADj5DI;EACI,6BAAA;EACA,8BAAA;ACo5DR;;ADj5DI;EACI,4BAAA;EACA,+BAAA;ACo5DR;;AD36DI;EACI,6BAAA;AC86DR;;AD36DI;EACI,8BAAA;AC86DR;;AD36DI;EACI,4BAAA;AC86DR;;AD36DI;EACI,+BAAA;AC86DR;;AD36DI;EACI,6BAAA;EACA,8BAAA;AC86DR;;AD36DI;EACI,4BAAA;EACA,+BAAA;AC86DR;;AC/hEA;EF2CI,eE1CkB;EF2ClB,QE3C+B;EF8C/B,SE9C2C;EAC3C,WAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;ADoiEJ;ACliEI;EACI,0CAAA;ADoiER;ACjiEI;EACI,iBAAA;ADmiER;AC/hEQ;EACI,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,SAAA;ADiiEZ;AC9hEgB;EACI,qBAAA;EFUhB,mBAAA;EERgB,cF1BZ;EE2BY,eAAA;EAGA,qBAAA;AD8hEpB;AC5hEoB;EACI,cFnCd;ACikEV;AC3hEoB;EACI,0BAAA;EACA,sBAAA;EACA,cFvChB;EEwCgB,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AD6hExB;AC3hEwB;EFJpB,kBEK0C;EFJ1C,QEI0D;EFH1D,QEGuE;EAC/C,WAAA;EACA,sEAAA;EACA,WAAA;EACA,WAAA;AD+hE5B;AC5hEwB;EACI,cFzDlB;EE0DkB,gBAAA;EACA,gBAAA;AD8hE5B;AC3hEwB;EAEI,gBAAA;EACA,gBAAA;AD4hE5B;ACvhEgB;EACI,qBAAA;EFnChB,mBAAA;EEqCgB,iBAAA;EACA,cFvEZ;EEwEY,qBAAA;EACA,iBAAA;EFxDhB,mBEyDuC;EACvB,kBAAA;EACA,mBF9ER;ACymEZ;ACzhEoB;EACI,cF/EhB;AC0mER;ACxhEoB;EFzChB,kBE0CsC;EFzCtC,SEyCsD;EFxCtD,WEwCoE;EFlEpE,mBEmE2C;EACvB,mBAAA;EACA,cFvFhB;EEwFgB,gBAAA;EACA,eAAA;AD8hExB;AC5hEwB;EFzDpB,oBAAA;EE2DwB,gBAAA;EACA,iBAAA;AD8hE5B;AC3hEwB;EACI,uBAAA;EACA,sBAAA;EACA,iCAAA;EACA,mCAAA;AD6hE5B;AC1hEwB;EACI,0BAAA;EACA,sBAAA;EACA,iCAAA;EACA,mCAAA;EACA,8BAAA;AD4hE5B;ACzhEwB;EACI;IACI,UAAA;ED2hE9B;ECxhE0B;IACI,YAAA;ED0hE9B;ECvhE0B;IACI,UAAA;EDyhE9B;AACF;ACthEwB;EACI;IACI,QAAA;EDwhE9B;ECrhE0B;IACI,UAAA;EDuhE9B;ECphE0B;IACI,QAAA;EDshE9B;AACF;ACjhEgB;EACI,mBFjJV;EEkJU,qBAAA;EF9GhB,mBAAA;EEgHgB,iBAAA;EACA,cFlJZ;EEmJY,qBAAA;EACA,iBAAA;EFnIhB,mBEoIuC;EACvB,YAAA;ADqhEpB;ACnhEoB;EACI,cFzJhB;AC8qER;ACjhEgB;EACI,qBAAA;EF7HhB,mBAAA;EE+HgB,iBAAA;EACA,cFjKZ;EEkKY,qBAAA;EACA,iBAAA;EFlJhB,mBEmJuC;EACvB,kBAAA;EACA,4BAAA;ADqhEpB;ACnhEoB;EACI,uBAAA;EACA,mCAAA;EACA,oBAAA;EACA,uBAAA;ADqhExB;AChhEgB;EACI,qBAAA;EFjJhB,mBAAA;EEmJgB,iBAAA;EACA,cFrLZ;EEsLY,oBAAA;EACA,iBAAA;EFtKhB,mBEuKuC;EACvB,kBAAA;EACA,0BAAA;EACA,oBAAA;ADohEpB;AClhEoB;EACI,YAAA;ADohExB;AC5gEY;EACI,SAAA;AD8gEhB;ACzgEI;EF3LA,+BE4L2B;EACvB,6DAAA;AD6gER;ACzgEQ;EACI,wCAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,yBAAA;EACA,0BAAA;EACA,4BAAA;AD2gEZ;ACxgEQ;EACI,2BAAA;AD0gEZ;ACzgEY;EACI,iCAAA;EACA,6BAAA;EACA,mBAAA;EACA,uBAAA;AD2gEhB;ACzgEgB;EACI,2BAAA;EACA,sBAAA;EACA,cFxOZ;EEyOY,4BAAA;EACA,cAAA;EACA,gBAAA;EACA,0BAAA;AD2gEpB;ACzgEoB;EACI,cFjPd;AC4vEV;ACxgEoB;EACI,2BAAA;AD0gExB;ACxgEwB;EACI,mBAAA;AD0gE5B;ACxgE4B;EACI,0BAAA;EACA,4BAAA;EACA,4BAAA;EACA,yBAAA;EACA,2BAAA;EACA,qBAAA;EACA,gBAAA;AD0gEhC;;AAvwEA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA;AAAA;;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA;AAAA;;AAAA,gEAAA;;AAAA;;;CAAA;;AAAA;;;EAAA,sBAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,mBAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;EAAA,gBAAA;AAAA;;AAAA;;;;;;;;CAAA;;AAAA;;EAAA,gBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA,EAAA,MAAA;EAAA,WAAA,EAAA,MAAA;EAAA,+HAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,wCAAA,EAAA,MAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,yCAAA;UAAA,iCAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;EAAA,kBAAA;EAAA,oBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,mBAAA;AAAA;;AAAA;;;;;CAAA;;AAAA;;;;EAAA,+GAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,cAAA;EAAA,cAAA;EAAA,kBAAA;EAAA,wBAAA;AAAA;;AAAA;EAAA,eAAA;AAAA;;AAAA;EAAA,WAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;EAAA,yBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;EAAA,oBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gCAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,uBAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,SAAA,EAAA,MAAA;EAAA,UAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,oBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;;;EAAA,0BAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,aAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,YAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,0BAAA,EAAA,MAAA;EAAA,aAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,kBAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;;;;;;;;EAAA,SAAA;AAAA;;AAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;EAAA,UAAA;AAAA;;AAAA;;;EAAA,gBAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,eAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;;;;EAAA,cAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;EAAA,YAAA;AAAA;;AAAA,wEAAA;;AAAA;EAAA,aAAA;AAAA;AACA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AACA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,wJAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAEA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,mCAAA;EACA,oBAAA;EACA,6BAAA;EACA,kCAAA;EACA,kCAAA;EACA,oBAAA;EACA,kCAAA;EACA,kCAAA;AAywEF;;AAtwEA;EACE,uBAAA;AAywEF;;AAtwEA;EACE,yBAAA;EACA,kCAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EDKE,eAAA;ECHF,kBAAA;EACA,mBAAA;EACA,2BAAA;EACA,gCAAA;EACA,mCAAA;EACA,sBAAA;EACA,8BAAA;AAywEF;;AAtwEA;;;;;;EAME,SAAA;AAywEF;;AAtwEA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AAywEF;AAvwEE;EALF;IAMI,eAAA;IACA,iBAAA;EA0wEF;AACF;AAxwEE;EAVF;IAWI,eAAA;IACA,iBAAA;EA2wEF;AACF;;AAxwEA;ED/BI,iBAAA;ECiCF,gBAAA;EACA,iBAAA;AA2wEF;;AAxwEA;EDrCI,eAAA;ECuCF,gBAAA;EACA,iBAAA;AA2wEF;;AAxwEA;ED3CI,iBAAA;EC6CF,gBAAA;EACA,iBAAA;AA2wEF;;AAxwEA;EDjDI,mBAAA;ECmDF,gBAAA;EACA,iBAAA;AA2wEF;;AAxwEA;EDvDI,eAAA;ECyDF,gBAAA;EACA,iBAAA;AA2wEF;;AAxwEA;ED7DI,mBAAA;EC+DF,gBAAA;EACA,iBAAA;EACA,sBAAA;AA2wEF;;AAxwEA;EACE,sBAAA;AA2wEF;;AAxwEA;EACE,SAAA;EACA,UAAA;AA2wEF;AAzwEE;EACE,gBAAA;AA2wEJ;;AAvwEA;EACE,iBAAA;EACA,WAAA;EACA,4BAAA;EACA,6BAAA;AA0wEF;;AAvwEA;EACE,WAAA;EACA,4BAAA;EACA,6BAAA;AA0wEF;;AAvwEA;EACE,eAAA;EACA,gCAAA;AA0wEF","sourcesContent":["// Color Variables\n$primary: #1E2E5F;\n$secondary: #BE2532;\n$black: #000000;\n$white: #ffffff;\n$grey: #808080;\n$red: #D9132E;\n$lightbg: #fbfbfb;\n$lightblue:#E9F1FD;\n\n\n/*--------------Mixins------------------*/\n@mixin box-shadow($shadow) {\n    -webkit-box-shadow: $shadow;\n    -moz-box-shadow: $shadow;\n    box-shadow: $shadow;\n}\n\n@mixin border-radius($radius: none) {\n    -webkit-border-radius: $radius;\n    -moz-border-radius: $radius;\n    border-radius: $radius;\n}\n\n@mixin appearance() {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n}\n\n@function calculateRem($size) {\n    $remSize: $size / 16px;\n    @return #{$remSize}rem;\n}\n\n@mixin fontSize($size) {\n    //font-size: $size;\n    font-size: calculateRem($size);\n}\n\n@mixin position($position,\n    $top: null,\n    $right: null,\n    $bottom: null,\n    $left: null) {\n    position: $position;\n    top: $top;\n    right: $right;\n    bottom: $bottom;\n    left: $left;\n}\n\n@mixin abs-position ($top, $right, $bottom, $left) {\n    // @include abs-position(10px, 10px, auto, auto);\n    position: absolute;\n    top: $top;\n    right: $right;\n    bottom: $bottom;\n    left: $left;\n}\n\n// Margins\n@for $i from 0 to 20 {\n    .ml-#{$i} {\n        margin-left: 4px * $i !important;\n    }\n\n    .mr-#{$i} {\n        margin-right: 4px * $i !important;\n    }\n\n    .mt-#{$i} {\n        margin-top: 4px * $i !important;\n    }\n\n    .mb-#{$i} {\n        margin-bottom: 4px * $i !important;\n    }\n\n    .mx-#{$i} {\n        margin-left: 4px * $i !important;\n        margin-right: 4px * $i !important;\n    }\n\n    .my-#{$i} {\n        margin-top: 4px * $i !important;\n        margin-bottom: 4px * $i !important;\n    }\n}\n\n// Paddings\n@for $i from 0 to 20 {\n    .pl-#{$i} {\n        padding-left: 4px * $i !important;\n    }\n\n    .pr-#{$i} {\n        padding-right: 4px * $i !important;\n    }\n\n    .pt-#{$i} {\n        padding-top: 4px * $i !important;\n    }\n\n    .pb-#{$i} {\n        padding-bottom: 4px * $i !important;\n    }\n\n    .px-#{$i} {\n        padding-left: 4px * $i !important;\n        padding-right: 4px * $i !important;\n    }\n\n    .py-#{$i} {\n        padding-top: 4px * $i !important;\n        padding-bottom: 4px * $i !important;\n    }\n}","@import \"./SCSS/Mixins.scss\";\n@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800;900&display=swap');\n@import \"./Components/Desktop/Navbar/Navbar.scss\";\n\n// tailwind css imports----\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n* {\n  margin: 0px;\n  padding: 0px;\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  text-rendering: auto;\n  text-rendering: optimizeSpeed;\n  text-rendering: optimizeLegibility;\n  text-rendering: geometricPrecision;\n  font-synthesis: none;\n  -moz-font-feature-settings: \"kern\";\n  -moz-osx-font-smoothing: grayscale;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nbody {\n  background-color: #ffffff;\n  font-family: \"Poppins\", sans-serif;\n  height: 100%;\n  margin: 0px;\n  padding: 0px;\n  @include fontSize(16px);\n  overflow-x: hidden;\n  font-smooth: always;\n  font-smoothing: antialiased;\n  -moz-font-smoothing: antialiased;\n  -webkit-font-smoothing: antialiased;\n  text-size-adjust: none;\n  -webkit-text-size-adjust: none;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin: 0;\n}\n\nh1 {\n  font-size: 50px;\n  line-height: 75px;\n  font-weight: 600;\n\n  @media(max-width:899px) {\n    font-size: 40px;\n    line-height: 60px;\n  }\n\n  @media(max-width:599px) {\n    font-size: 36px;\n    line-height: 54px;\n  }\n}\n\nh2 {\n  @include fontSize(40px);\n  font-weight: 600;\n  line-height: 60px;\n}\n\nh3 {\n  @include fontSize(32px);\n  font-weight: 600;\n  line-height: 42px;\n}\n\nh4 {\n  @include fontSize(24px);\n  font-weight: 600;\n  line-height: 36px;\n}\n\nh5 {\n  @include fontSize(18px);\n  font-weight: 600;\n  line-height: 30px;\n}\n\nh6 {\n  @include fontSize(16px);\n  font-weight: 600;\n  line-height: 24px;\n}\n\np {\n  @include fontSize(14px);\n  font-weight: 400;\n  line-height: 21px;\n  color: rgba(89, 89, 89, 1);\n}\n\nimg {\n  vertical-align: middle;\n}\n\nul {\n  margin: 0;\n  padding: 0;\n\n  li {\n    list-style: none;\n  }\n}\n\n.row {\n  max-width: 1224px;\n  width: 100%;\n  margin-left: auto !important;\n  margin-right: auto !important;\n}\n\n.MuiGrid2-container {\n  width: 100%;\n  margin-left: auto !important;\n  margin-right: auto !important;\n}\n\na {\n  cursor: pointer;\n  text-decoration: none !important;\n}\n","@import \"./../../../SCSS/Mixins.scss\";\n\n.Navbar {\n    @include position(fixed, $top: 0px, $left: 0px);\n    z-index: 99;\n    width: 100%;\n    padding: 16px 0px;\n    min-height: 156px;\n    background: #E9F1FD;\n\n    &.box-shadow {\n        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);\n    }\n\n    .row {\n        max-width: 1800px;\n    }\n\n    .nav-section {\n        ul {\n            display: flex;\n            align-items: center;\n            justify-content: end;\n            gap: 20px;\n\n            li {\n                .nav-link {\n                    text-decoration: none;\n                    @include fontSize(14px);\n                    color: $black;\n                    cursor: pointer;\n                    // padding-top: 4px;\n                    // padding-bottom: 4px;\n                    display: inline-block;\n\n                    &:hover {\n                        color: $primary;\n                    }\n\n                    &.product-link {\n                        text-transform: capitalize;\n                        font-family: \"poppins\";\n                        color: $black;\n                        padding: 0px 16px 0px 0px;\n                        min-height: 10px;\n                        font-weight: 400;\n                        position: relative;\n                        line-height: 21px;\n\n                        &:before {\n                            @include position(absolute, $top: 8px, $right: 0);\n                            content: '';\n                            background: url(\"./../../../../public/images/bottom-dropdown-icon.svg\") no-repeat 0 0/10px;\n                            height: 7px;\n                            width: 10px;\n                        }\n\n                        &:hover {\n                            color: $primary;\n                            background: none;\n                            transition: none;\n                        }\n\n                        &:focus,\n                        &:active {\n                            background: none;\n                            transition: none;\n                        }\n                    }\n                }\n\n                .ca-link {\n                    text-decoration: none;\n                    @include fontSize(14px);\n                    line-height: 21px;\n                    color: $white;\n                    display: inline-block;\n                    padding: 8px 16px;\n                    @include border-radius(30px);\n                    position: relative;\n                    background: $secondary;\n\n                    &:hover {\n                        color: $white;\n                    }\n\n                    span {\n                        @include position(absolute, $top: -8px, $right: 12px);\n                        @include border-radius(30px);\n                        background: #F8E007;\n                        color: $black;\n                        padding: 2px 8px;\n                        display: inline;\n\n                        p {\n                            @include fontSize(9px);\n                            font-weight: 600;\n                            line-height: 10px;\n                        }\n\n                        .blink_text {\n                            animation-name: blinker;\n                            animation-duration: 1s;\n                            animation-timing-function: linear;\n                            animation-iteration-count: infinite;\n                        }\n\n                        &.boxblink {\n                            animation-name: boxblinker;\n                            animation-duration: 1s;\n                            animation-timing-function: linear;\n                            animation-iteration-count: infinite;\n                            transition: all ease-in-out 1s;\n                        }\n\n                        @keyframes blinker {\n                            0% {\n                                opacity: 1.0;\n                            }\n\n                            50% {\n                                opacity: 0.1;\n                            }\n\n                            100% {\n                                opacity: 1.0;\n                            }\n                        }\n\n                        @keyframes boxblinker {\n                            0% {\n                                scale: 1;\n                            }\n\n                            50% {\n                                scale: 0.8;\n                            }\n\n                            100% {\n                                scale: 1;\n                            }\n                        }\n                    }\n                }\n\n                .pir-link {\n                    background: $primary;\n                    text-decoration: none;\n                    @include fontSize(14px);\n                    line-height: 21px;\n                    color: $white;\n                    display: inline-block;\n                    padding: 8px 16px;\n                    @include border-radius(30px);\n                    border: none;\n\n                    &:hover {\n                        color: $white;\n                    }\n                }\n\n                .login {\n                    text-decoration: none;\n                    @include fontSize(14px);\n                    line-height: 21px;\n                    color: $white;\n                    display: inline-block;\n                    padding: 8px 16px;\n                    @include border-radius(30px);\n                    position: relative;\n                    background: rgba(196, 61, 73, 1);\n\n                    &:hover {\n                        color: rgba(196, 61, 73, 1);\n                        outline: 1px solid rgba(196, 61, 73, 1);\n                        outline-offset: -1px;\n                        background: transparent;\n                    }\n\n                }\n\n                .logo-link {\n                    text-decoration: none;\n                    @include fontSize(14px);\n                    line-height: 21px;\n                    color: $white;\n                    display: inline-flex;\n                    padding: 6px 16px;\n                    @include border-radius(30px);\n                    position: relative;\n                    outline: 1px solid $primary;\n                    outline-offset: -1px;\n\n                    img {\n                        height: 25px\n                    }\n\n                }\n            }\n        }\n\n        &.ns2{\n            ul{\n                gap: 15px\n            }\n        }\n    }\n\n    .rounded {\n        @include border-radius(100px !important);\n        box-shadow: 0px 6px 7px 0px rgba(0, 181, 135, 0.2) !important;\n    }\n\n    .mutilevel {  \n        button {\n            background-color: transparent !important;\n            padding: 0 !important;\n            height: 20px !important;\n            font-weight: 400 !important;\n            color: $black !important;\n            font-size: 14px !important;\n            letter-spacing: 0 !important;\n        }\n\n        .dropdown {\n            min-width: 240px !important;\n            ul {\n                flex-direction: column !important;\n                align-items: start !important;\n                gap: 4px !important;\n                margin: 12px !important;\n\n                li {\n                    padding: 4px 8px !important;\n                    width: 100% !important;\n                    color: $black;\n                    white-space: wrap !important;\n                    display: block;\n                    text-align: left;\n                    font-size: 13px !important;\n\n                    &:hover {\n                        color: $primary;\n                    }\n\n                    .submenu {\n                        min-width: 200px !important;\n\n                        ul {\n                            gap: 2px !important;\n\n                            .submenu-item{\n                                font-size: 12px !important;\n                                line-height: 18px !important;\n                                white-space: wrap !important;\n                                display: block !important;\n                                text-align: left !important;\n                                list-style-type: disc;\n                                padding: 4px 2px;\n                            }\n                        }\n\n                    }\n                }\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
